import { ObterNotificacoes } from "./metodos/ObterNotificacoes";
import { ObterNotificacoesPorId } from "./metodos/ObterNotificacoesPorId";

export const NotificacaoService = {
    ObterNotificacoes,
    ObterNotificacoesPorId
}